// Converts a Flux relative-duration literal ("0m", "-90d", "15m", "1h", "1w", "1mo")
// to minutes. Returns null for anything else (e.g. "today()"), which callers
// treat as "leave it alone".
function toMinutes(duration) {
  const match = /^(-?\d+)(mo|m|h|d|w)$/.exec(duration)
  if (!match) return null
  const value = parseInt(match[1], 10)
  const unitMinutes = { m: 1, h: 60, d: 1440, w: 10080, mo: 43200 }
  return value * unitMinutes[match[2]]
}

// aggregateWindow's last bucket in the query range is clipped at `stop`, so it can
// hold far less than a full `interval` of samples yet still be spaced a full interval
// from the previous bucket. Deriving a rate across that gap divides a normal packet
// delta by an artificially short time delta, spiking/dipping the last plotted point.
// Trimming one interval off `stop` keeps every remaining aggregateWindow bucket full-sized.
function trimTrailingWindow(stop, interval) {
  const stopMinutes = toMinutes(stop)
  const intervalMinutes = toMinutes(interval)
  if (stopMinutes === null || intervalMinutes === null) return stop
  return `${stopMinutes - intervalMinutes}m`
}

export function createQuery(host,iface,type, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m") {
    var query = "";
    if (type === 'snmp'){
         query = `
            incoming_bandwidth = from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "interface" and r["_field"] == "ifInUcastPkts")
            |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
            |> derivative(unit: 1s)
            |> map(fn: (r) => ({
                _time: r._time,
                _field: "input_bps",
                 _value: (if r._value < 0.0 then -1.0 * float(v: r._value) else float(v: r._value)) // Convert bytes to bits per second
            }))
            |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)

            // OUTGOING Bandwidth Utilization
            outgoing_bandwidth = from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "interface" and r["_field"] == "ifOutUcastPkts")
            |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
            |> derivative(unit: 1s)
            |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
            |> map(fn: (r) => ({
                _time: r._time,
                _field: "output_bps",
                _value: (if r._value < 0.0 then -1.0 * float(v: r._value) else float(v: r._value)) // Convert bytes to bits per second
            }))

            union(tables: [incoming_bandwidth, outgoing_bandwidth])
            |> yield(name: "bwutil_bps")
            `

            return query;
        } 
 
    else {
        //    query = `
        //     from(bucket: "telegraf")
        //     |> range(start: ${durationStart}, stop: ${durationEnd})
        //     |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_rx" or r["_measurement"] == "ezelink_interface_tx")
        //     |> filter(fn: (r) => r["type"] == "if_packets")
        //     |> filter(fn: (r) => r["host"] == "${host}")
        //     |> filter(fn: (r) => r["instance"] == "${iface}")
        //     |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: false)
        //     |> derivative(unit: 1s, nonNegative: true) // <-- this line gives you bytes/sec
        //     |> yield(name: "mean")
        //     `
        //     return query;
        const trimmedStop = trimTrailingWindow(durationEnd, durationInterval)
        query = `
            from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${trimmedStop})
            |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_rx" or r["_measurement"] == "ezelink_interface_tx")
            |> filter(fn: (r) => r["type"] == "if_packets")
            |> filter(fn: (r) => r["host"] == "${host}")
            |> filter(fn: (r) => r["instance"] == "${iface}")
            |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
            |> derivative(unit: 1s, nonNegative: true)
            `
            return query;
            
    }
}